<template>
  <router-view />
</template>

<script>
export default {
  name: "sy",
};
</script>